import { render, staticRenderFns } from "./Draw.vue?vue&type=template&id=2ac9367f&scoped=true&lang=pug&"
import script from "./Draw.vue?vue&type=script&lang=ts&"
export * from "./Draw.vue?vue&type=script&lang=ts&"
import style0 from "./Draw.vue?vue&type=style&index=0&id=2ac9367f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac9367f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VBtnToggle,VSlider})
